<template lang="pug">
  
  div( class="text-right" )
    | Data latest as of: {{ dateFormat(refreshedAt, 'HH:MM:ss') }}
    button( class="btn btn-primary ml-2" v-bind:disabled="refreshing" v-on:click="refresh" )
      span( v-if="refreshing" )
        MLoadingSpinner( class="mr-2" )
        | Refreshing...
      span( v-else ) Refresh results

</template>

<script>
import Vue from 'vue'
import * as dateFormat from 'dateformat'
export default Vue.extend({

  props: [ 'apolloQuery' ],

  data() {
    return {
      refreshCooldown: false,
      refreshing: false,
      refreshedAt: Date.now()
    }
  },

  methods: {
    dateFormat,

    refresh() {
      
      // Fake refresh for UX
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.refreshedAt = Date.now()
      }, 500)

      // Real refresh on 10s cooldown
      if (! this.refreshCooldown) {
        this.refreshCooldown = true
        setTimeout(() => this.refreshCooldown = false, 10000)
        if (Array.isArray(this.apolloQuery)) {
          this.apolloQuery.forEach(query => query.refresh())
        }
        else {
          this.apolloQuery.refresh()
        }
      }
    }
  }

})
</script>